import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	HStack,
	Button,
	Checkbox,
	Textarea,
	Switch,
	FormLabel,
	FormControl,
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../../components/form'
import { fetchWrapper } from '../../../../helpers';
import { LuArrowLeftCircle } from "react-icons/lu";
import { Field } from "formik";
function EditForm({ getPage, channel_id, rs }) {
	const [customerList, setCustomerList] = useState([]);
	const [countryList, setCountryList] = useState([]);

	const apiConfig = JSON.parse(rs.api_config);

	const [showAutoResponse, setShowAutoResponse] = useState(
		apiConfig.auto_response && apiConfig.auto_response !== false
	);
	const [marketingMessagesLite, setMarketingMessagesLite] = useState(
		apiConfig.marketing_messages_lite === 1 || apiConfig.marketing_messages_lite === true
	);
	const [authInt, setAuthInt] = useState(
		apiConfig.auth_int === 1 || apiConfig.auth_int === true
	);

	const [formData, setFormData] = useState({
		account_name: rs.account_name,
		customer_id: rs.customer_id,
		business_name: apiConfig.business_name,
		token: apiConfig.token,
		business_number: apiConfig.business_number,
		display_number: apiConfig?.display_number || '',
		status_id: rs.status_id,
		waba_id: apiConfig?.waba_id,
		app_id: apiConfig?.app_id,
		country_id: apiConfig?.country_id,
		auto_response: apiConfig?.auto_response && apiConfig.auto_response !== false
			? apiConfig.auto_response
			: "", // prevent "false" text showing
		id: rs.id
	});

	const FormSchema = Yup.object().shape({
		account_name: Yup.string().required('Required'),
		customer_id: Yup.string().required('Required'),
		business_name: Yup.string().required('Required'),
		business_number: Yup.string().required('Required'),
		display_number: Yup.string()
			.matches(/^\d+$/, 'Only numbers are allowed')
			.required('Required'),
		waba_id: Yup.string().required('Required'),
		app_id: Yup.string().required('Required'),
		country_id: Yup.string().required('Required'),
		token: Yup.string().required('Required'),
		auto_response: Yup.mixed() // can be false or string
	});

	useEffect(() => {
		loadCustomerList();
		loadCountryList();
	}, []);

	const loadCustomerList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/customer/list`;
		const response = await fetchWrapper.get(url);
		const customerList = response.data;
		const allCustomersEntry = { id: 0, name: "All Customers" };
		const updatedData = [allCustomersEntry, ...customerList];
		let data = updatedData?.map(item => ({ id: item.id, name: item.business_name || item.name }))
		const db = { data: data };
		setCustomerList(db);
	};

	const loadCountryList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/country/list`;
		const response = await fetchWrapper.get(url);
		const countryList = response.rows;
		setCountryList({ data: countryList });
	};

	const statusList = {
		data: [
			{ id: '1', name: 'Active' },
			{ id: '0', name: 'InActive' }
		]
	};

	const onSubmit = async (values) => {
		let data = { ...values };

		// if auto response is disabled → force false
		if (!showAutoResponse) {
			data.auto_response = false;
		}

		const api_config = {
			business_name: data.business_name,
			token: data.token,
			business_number: data.business_number,
			display_number: data.display_number,
			waba_id: data.waba_id,
			app_id: data.app_id,
			country_id: data.country_id,
			auto_response: showAutoResponse ? data.auto_response : false,
			marketing_messages_lite: marketingMessagesLite ? 1 : 0,
			auth_int: authInt ? 1 : 0,
		};

		const postData = {
			customer_id: data.customer_id,
			status_id: data.status_id,
			api_config,
			account_name: data.account_name,
			id: rs.id
		};

		const url = `${process.env.REACT_APP_API_URL}/channel_api_config/update`;
		await fetchWrapper.post(url, postData);

		getPage('list');
	};

	return (
		<div className="setting_detail_section">
			<HStack>
				<Box>
					<LuArrowLeftCircle
						style={{ fontSize: '24px', cursor: 'pointer' }}
						onClick={() => getPage('list', channel_id)}
					/>
				</Box>
				<Box>
					<h2 className="main_heading">WhatsApp Account</h2>
				</Box>
			</HStack>

			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>
				<InputText name="account_name" title="Account Name" inputProps={{ isRequired: true }} />
				<SelectField name="customer_id" title="Customers" list={customerList} isRequired />

				<InputText name="business_name" title="Business Name" inputProps={{ isRequired: true }} />
				<InputText name="business_number" title="Phone Number Id" inputProps={{ isRequired: true }} />

				<InputText name="waba_id" title="Waba Id" inputProps={{ isRequired: true }} />
				<InputText name="app_id" title="App Id" inputProps={{ isRequired: true }} />

				<SelectField name="country_id" title="Phone # Country" list={countryList} isRequired />
				<InputText
					name="display_number"
					title="Display Phone Number"
					inputProps={{
						isRequired: true,
						inputMode: 'numeric',
						onKeyPress: (e) => { if (!/[0-9]/.test(e.key)) e.preventDefault(); },
					}}
				/>
				<InputText name="token" title="Token" inputProps={{ isRequired: true }} />

				{/* Auto Response Toggle */}
				<Box my={4}>
					<Checkbox
						isChecked={showAutoResponse}
						onChange={(e) => setShowAutoResponse(e.target.checked)}
					>
						Enable Auto Response
					</Checkbox>

					{showAutoResponse && (
						<Field name="auto_response">
							{({ field }) => (
								<Textarea
									{...field}   // <-- bind to Formik
									placeholder="Enter auto response text"
									mt={2}
								/>
							)}
						</Field>
					)}
				</Box>

				<FormControl my={3}>
					<HStack spacing={3} align="center">
						<Switch
							id="marketing_messages_lite"
							isChecked={marketingMessagesLite}
							onChange={(e) => setMarketingMessagesLite(e.target.checked)}
						/>
						<FormLabel htmlFor="marketing_messages_lite" mb={0} fontSize="sm" fontWeight="medium">
							Marketing Messages Lite
						</FormLabel>
					</HStack>
				</FormControl>

				<FormControl my={3}>
					<HStack spacing={3} align="center">
						<Switch
							id="auth_int"
							isChecked={authInt}
							onChange={(e) => setAuthInt(e.target.checked)}
						/>
						<FormLabel htmlFor="auth_int" mb={0} fontSize="sm" fontWeight="medium">
							Allow Authentication International on Local numbers
						</FormLabel>
					</HStack>
				</FormControl>

				<Box w="30%">
					<SelectField name="status_id" title="Status" list={statusList} isRequired />
				</Box>

				<Button
					py="10px"
					px="25px"
					color="#fff"
					bg="#2563eb"
					fontSize="14px"
					fontWeight="500"
					fontFamily="'Open Sans', sans-serif"
					mb={4}
					type='submit'
				>
					Edit WhatsApp Account
				</Button>
			</Form>
		</div>
	);
}

export default EditForm;
